import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Home = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.3201 1.11589C8.13468 0.96137 7.86534 0.96137 7.67992 1.11589L1.67992 6.11589C1.46778 6.29267 1.43912 6.60795 1.6159 6.82009C1.79268 7.03223 2.10797 7.06089 2.3201 6.88411L2.50001 6.73419V13.5C2.50001 13.7761 2.72387 14 3.00001 14H13C13.2762 14 13.5 13.7761 13.5 13.5V6.73419L13.6799 6.88411C13.8921 7.06089 14.2073 7.03223 14.3841 6.82009C14.5609 6.60795 14.5322 6.29267 14.3201 6.11589L8.3201 1.11589ZM12.5085 5.90791L8.00001 2.15085L3.49155 5.90791C3.49711 5.93776 3.50001 5.96854 3.50001 6V13H12.5V6C12.5 5.96854 12.5029 5.93776 12.5085 5.90791Z"
      />
    </svg>
  )
})

export default Home
